import { render, staticRenderFns } from "./ShippingCalculator.vue?vue&type=template&id=50a1f304"
import script from "./ShippingCalculator.vue?vue&type=script&lang=js"
export * from "./ShippingCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports